// Modal opener controller
// Opens a modal (Ui::ModalComponent / Ui::AlertModalComponent) that lives
// outside the current Stimulus scope (e.g. a trigger button inside a bottom
// drawer that needs to open a confirmation modal rendered at the page root).
//
// Usage:
//   <button data-controller="ui--modal-opener"
//           data-ui--modal-opener-modal-id-value="my-modal"
//           data-action="click->ui--modal-opener#open">
//     Open
//   </button>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { modalId: String }

  open() {
    const modalEl = document.getElementById(this.modalIdValue)
    if (!modalEl) return

    const controller = this.application.getControllerForElementAndIdentifier(
      modalEl,
      "ui--modal",
    )
    controller?.open()
  }
}
